// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0[data-v-45b2bf36] {\n  fill: #ffbeb6;\n}\n.st2[data-v-45b2bf36] {\n  fill: #1A7BEE;\n}\n.st3[data-v-45b2bf36] {\n  fill: #e94766;\n}\n.st4[data-v-45b2bf36] {\n  fill: #fff;\n}\n.st5[data-v-45b2bf36] {\n  fill: none;\n}\n.st6[data-v-45b2bf36] {\n  fill: #a1e7fc;\n}\n.st8[data-v-45b2bf36] {\n  fill: #a1c3fc;\n}\n.st14[data-v-45b2bf36] {\n  fill: #eee;\n}\n", ""]);
// Exports
module.exports = exports;
